exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".star-rating[data-v-1913d70c] {\n  display: flex;\n  align-items: center;\n}\n.star-rating .star-container[data-v-1913d70c] {\n  display: flex;\n}\n.star-rating .star-container[data-v-1913d70c]:not(:last-child) {\n  margin-right: 5px;\n}", ""]);

// exports
